import { useCallback, useEffect, useState } from "react";
import { Alert, Button, Card } from "antd";
import { ExternalLink, RefreshCw, WalletCards } from "lucide-react";
import { edge } from "../../lib/supabase.js";
export function PointManagementPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const refresh = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setData(await edge("payssam-balance", null, "GET"));
    } catch (failure) {
      setData(null);
      setError(failure.message);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const chargeUrl = (() => {
    try {
      const url = new URL(data?.chargeUrl);
      return url.protocol === "https:" ? url.href : null;
    } catch {
      return null;
    }
  })();
  return (
    <section className="page-stack point-management-page">
      {error && (
        <Alert
          type="error"
          message={error}
          action={<Button onClick={refresh}>재시도</Button>}
        />
      )}
      <Card className="academy-management-card payment-surface-shadow point-balance-card">
        <div className="point-balance-card-header">
          <span className="point-balance-icon">
            <WalletCards size={18} />
          </span>
          <strong>쌤포인트 잔액</strong>
        </div>
        <div className="point-balance-value">
          <span>잔여 쌤포인트</span>
          <strong>
            {data ? `${data.balance.toLocaleString("ko-KR")}P` : "-"}
          </strong>
        </div>
        <div className="point-balance-checked">
          <span>마지막 조회</span>
          <time>
            {data
              ? new Intl.DateTimeFormat("ko-KR", {
                  timeZone: "Asia/Seoul",
                  dateStyle: "medium",
                  timeStyle: "short",
                }).format(new Date(data.fetchedAt))
              : "-"}
          </time>
          <Button
            loading={loading}
            icon={<RefreshCw size={14} />}
            onClick={refresh}
          >
            새로고침
          </Button>
        </div>
        <Button
          className="point-charge-button"
          type="primary"
          block
          disabled={!chargeUrl || loading}
          href={chargeUrl || undefined}
          target="_blank"
          rel="noopener noreferrer"
          icon={<ExternalLink size={15} />}
        >
          충전하기
        </Button>
      </Card>
      <Card className="academy-management-card point-management-notice">
        <p>청구서 알림톡 발송 시 쌤포인트가 차감됩니다.</p>
        <p>충전 및 자동충전 설정은 결제선생에서 진행합니다.</p>
      </Card>
    </section>
  );
}
